import InfoGraphicChart from './infoGraphicChart.module';

export default class InfoGraphicChartColumn extends InfoGraphicChart {
  constructor( node, data ) {
    super( node, data );
  }

  setOptions() {
    super.setOptions();
    this.setGeneralOptions();
    if ( this.options.series.length > 1 ) {
      this.setMultiSeriesOptions();
    } else {
      this.setSingleSeriesOptions();
    }
  }

  setGeneralOptions() {
    this.mergeObjects( this.options, {
      chart: {
        height: 500
      },
      colors: [ '#004B95', '#0096C1', '#00C6FF', '#C8ED10', '#A4C20F', '#FFD904', '#CCDBEA', '#2586E6' ],
      plotOptions: {
        column: {
          borderWidth: 0,
          groupPadding: 0.05,
          dataLabels: {
            allowOverlap: true,
            crop: false,
            overflow: 'none',
            formatter: function() {
              let language = document.documentElement.lang;
              if ( language === 'de' ) {
                return this.y.toLocaleString();
              } else {
                return this.y.toLocaleString( 'en-GB' );
              }
            }
          }
        }
      },
      tooltip: {
        backgroundColor: 'transparent',
        borderWidth: 0,
        padding: 0,
        useHTML: true,
        formatter: function() {
          let language = document.documentElement.lang;
          if ( language === 'de' ) {
            return `
            <div class="charts-highchart__tooltip">
                <span>${this.x} ${this.series.chart.userOptions.xAxis.title.text}</span>
                <br>
                <strong>${this.y.toLocaleString()} ${this.series.chart.userOptions.yAxis[ 0 ].title.text}</strong>
                <svg class="charts-highchart__tooltip-arrow" width="16" height="16" viewBox="0 0 100 100">
                    <polygon fill="white" points="0 0 100 0 50 65"></polygon>
                </svg>
            </div>
            `;
          } else {
            return `
            <div class="charts-highchart__tooltip">
                <span>${this.x} ${this.series.chart.userOptions.xAxis.title.text}</span>
                <br>
                <strong>${this.y.toLocaleString( 'en-GB' )} ${this.series.chart.userOptions.yAxis[ 0 ].title.text}</strong>
                <svg class="charts-highchart__tooltip-arrow" width="16" height="16" viewBox="0 0 100 100">
                    <polygon fill="white" points="0 0 100 0 50 65"></polygon>
                </svg>
            </div>
            `;
          }
        }
      },
      xAxis: {
        lineWidth: 0,
        tickWidth: 0,
        labels: {
          rotation: 0,
          style: {
            fontSize: '18px'
          }
        },
        title: {
          enabled: false
        }
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 767
            },
            chartOptions: {
              xAxis: {
                labels: {
                  rotation: -45,
                }
              }
            }
          }
        ]
      }
    });

    this.mergeObjects( this.options.yAxis[ 0 ],
      {
        gridLineWidth: 0,
        title: {
          enabled: false
        },
        labels: {
          style: {
            fontSize: '18px'
          },
          formatter: function() {
            let language = document.documentElement.lang;
            if ( language === 'de' ) {
              return this.value.toLocaleString();
            } else {
              return this.value.toLocaleString( 'en-GB' );
            }
          }
        }
      }
    );
  }

  setSingleSeriesOptions() {
    this.mergeObjects( this.options, {
      colors: [
        {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [ 0, '#004B95' ],
            [ 1, 'rgba(0, 75, 149, 0.5)' ]
          ]
        }
      ],
      plotOptions: {
        column: {
          states: {
            hover: {
              color: {
                linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                stops: [
                  [ 0, '#0096C1' ],
                  [ 1, 'rgba(0, 150, 193, 0.5)' ]
                ]
              }
            }
          }
        }
      }
    });
  }

  setMultiSeriesOptions() {

    // store keys of groups where we already have a data label
    let keys = [];

    this.mergeObjects( this.options, {
      chart: {
        // empty sotred keys for next rendering
        events: {
          render: () => keys = []
        },
      },
      tooltip: {
        formatter: function() {
          let language = document.documentElement.lang;
          if ( language === 'de' ) {
            return `
            <div class="charts-highchart__tooltip">
                <span>${this.x} ${this.series.name}</span>
                <br>
                <strong>${this.y.toLocaleString()} ${this.series.chart.userOptions.yAxis[ 0 ].title.text}</strong>
                <svg class="charts-highchart__tooltip-arrow" width="16" height="16" viewBox="0 0 100 100">
                    <polygon fill="white" points="0 0 100 0 50 65"></polygon>
                </svg>
            </div>
            `;
          } else {
            return `
            <div class="charts-highchart__tooltip">
                <span>${this.x} ${this.series.name}</span>
                <br>
                <strong>${this.y.toLocaleString( 'en-GB' )} ${this.series.chart.userOptions.yAxis[ 0 ].title.text}</strong>
                <svg class="charts-highchart__tooltip-arrow" width="16" height="16" viewBox="0 0 100 100">
                    <polygon fill="white" points="0 0 100 0 50 65"></polygon>
                </svg>
            </div>
            `;
          }

        }
      },
      legend: {
        shadow: false,
        squareSymbol: true,
        symbolHeight: 20,
        symbolWidth: 20,
        symbolRadius: 0,
        symbolPadding: 5,
        itemDistance: 40,
        itemStyle: {
          fontSize: '18px'
        },
        align: 'center',
        backgroundColor: 'none',
        borderWidth: 0,
        enabled: true,
        verticalAlign: 'top',
        layout: 'horizontal',
        floating: false,
        x: 0,
        y: 0,
        useHTML: true,
        margin: 50,
        itemMarginBottom: 15
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: false,
          }
        }
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 767 + 20 * 2
            },
            chartOptions: {
              legend: {
                padding: 0,
                align: 'left',
                itemDistance: 20

              },
              xAxis: {
                labels: {
                  rotation: -45,
                }
              }
            }
          }
        ]
      }
    });

    this.mergeObjects( this.options.yAxis[ 0 ],
      {
        reversedStacks: false,
        stackLabels: {
          enabled: true,
          y: -15,
          formatter: function() {
            let language = document.documentElement.lang;
            if ( language === 'de' ) {
              return this.total.toLocaleString();
            } else {
              return this.total.toLocaleString( 'en-GB' );
            }
          },
          style: {
            textOutline: 0
          }
        }
      }
    );
  }
}
